import { jsPDF } from "jspdf";

const FOREST = [34, 70, 51];
const INK = [38, 38, 36];
const INK_MUTED = [92, 92, 86];

export function downloadFormationBrochure(t, lang) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const marginX = 48;
  const maxWidth = pageWidth - marginX * 2;
  let y = 56;

  const ensureSpace = (needed) => {
    if (y + needed > pageHeight - 40) {
      doc.addPage();
      y = 56;
    }
  };

  const addHeading = (text, size = 13) => {
    ensureSpace(size + 16);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(size);
    doc.setTextColor(...FOREST);
    doc.text(text, marginX, y);
    y += size + 8;
  };

  const addParagraph = (text, { size = 10, color = INK_MUTED, bold = false, italic = false } = {}) => {
    doc.setFont("helvetica", bold ? "bold" : italic ? "italic" : "normal");
    doc.setFontSize(size);
    doc.setTextColor(...color);
    const lines = doc.splitTextToSize(text, maxWidth);
    lines.forEach((line) => {
      ensureSpace(size + 4);
      doc.text(line, marginX, y);
      y += size + 4;
    });
    y += 4;
  };

  const addBullet = (text, { size = 10 } = {}) => {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(size);
    doc.setTextColor(...INK_MUTED);
    const lines = doc.splitTextToSize(text, maxWidth - 14);
    lines.forEach((line, i) => {
      ensureSpace(size + 3);
      if (i === 0) {
        doc.setFillColor(...FOREST);
        doc.circle(marginX + 3, y - 3, 1.6, "F");
      }
      doc.text(line, marginX + 14, y);
      y += size + 3;
    });
  };

  // Header
  doc.setFillColor(...FOREST);
  doc.rect(0, 0, pageWidth, 6, "F");

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(...FOREST);
  doc.text(t("formation.eyebrow").toUpperCase(), marginX, y);
  y += 20;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.setTextColor(...INK);
  const titleLines = doc.splitTextToSize(t("formation.title"), maxWidth);
  titleLines.forEach((line) => {
    doc.text(line, marginX, y);
    y += 22;
  });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(...FOREST);
  doc.text(t("formation.subtitle"), marginX, y);
  y += 24;

  addParagraph(t("formation.intro"), { size: 10 });

  addHeading(t("formation.for_you_title"), 12);
  ["for_you_1", "for_you_2", "for_you_3", "for_you_4", "for_you_5", "for_you_6"].forEach((k) =>
    addBullet(t(`formation.${k}`))
  );
  y += 6;

  addHeading(t("formation.programme_title"), 12);
  addParagraph(`${t("formation.welcome_title")} — ${t("formation.welcome_text")}`, { size: 10 });
  addParagraph(`${t("formation.immersion_title")} — ${t("formation.immersion_text")}`, { size: 10 });
  ["immersion_1", "immersion_2", "immersion_3", "immersion_4", "immersion_5"].forEach((k) =>
    addBullet(t(`formation.${k}`))
  );
  y += 4;
  addParagraph(`${t("formation.conclusion_title")} — ${t("formation.conclusion_text")}`, { size: 10 });

  addHeading(t("formation.ateliers_title"), 12);
  addParagraph(t("formation.ateliers_text"), { size: 10 });
  [
    "ateliers_1",
    "ateliers_2",
    "ateliers_3",
    "ateliers_4",
    "ateliers_5",
    "ateliers_6",
    "ateliers_7",
    "ateliers_8",
    "ateliers_9",
  ].forEach((k) => addBullet(t(`formation.${k}`)));
  y += 6;

  addHeading(t("formation.dates_title"), 12);
  addBullet(t("formation.dates_1"));
  addBullet(t("formation.dates_2"));
  y += 6;

  addHeading(t("formation.cancellation_title"), 12);
  addParagraph(t("formation.cancellation_intro"), { size: 10 });
  ["cancellation_option_1", "cancellation_option_2", "cancellation_option_3"].forEach((k) =>
    addBullet(t(`formation.${k}`))
  );
  y += 6;

  addHeading(t("formation.hours_title"), 12);
  ["hours_sun", "hours_weekdays", "hours_wed", "hours_sat"].forEach((k) => addBullet(t(`formation.${k}`)));
  y += 6;

  addHeading(t("formation.formateurs_title"), 12);
  ["formateur_claire", "formateur_louise", "formateur_emilie", "formateur_magali"].forEach((k) =>
    addBullet(t(`formation.${k}`))
  );
  addParagraph(t("formation.formateurs_team_note"), { size: 10 });
  addParagraph(t("formation.formateur_salma"), { size: 9.5, italic: true });

  addHeading(t("formation.tarifs_title"), 12);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.setTextColor(...FOREST);
  ensureSpace(20);
  doc.text(t("formation.tarifs_price"), marginX, y);
  y += 20;
  addParagraph(`${t("formation.tarifs_signup")} ${t("formation.tarifs_contact_email")}`, { size: 10 });
  addParagraph(t("formation.tarifs_deposit"), { size: 10 });

  addHeading(t("formation.financing_title"), 12);
  addParagraph(t("formation.financing_intro"), { size: 10 });
  addParagraph("ecolepleinenature.org", { size: 9.5, bold: true, color: FOREST });

  const fileName = lang === "en" ? "EPN-training-brochure.pdf" : "EPN-brochure-formation.pdf";
  doc.save(fileName);
}

export function downloadFormationOnlineBrochure(t, lang) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const marginX = 48;
  const maxWidth = pageWidth - marginX * 2;
  let y = 56;

  const ensureSpace = (needed) => {
    if (y + needed > pageHeight - 40) {
      doc.addPage();
      y = 56;
    }
  };

  const addHeading = (text, size = 13) => {
    ensureSpace(size + 16);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(size);
    doc.setTextColor(...FOREST);
    doc.text(text, marginX, y);
    y += size + 8;
  };

  const addParagraph = (text, { size = 10, color = INK_MUTED, bold = false, italic = false } = {}) => {
    doc.setFont("helvetica", bold ? "bold" : italic ? "italic" : "normal");
    doc.setFontSize(size);
    doc.setTextColor(...color);
    const lines = doc.splitTextToSize(text, maxWidth);
    lines.forEach((line) => {
      ensureSpace(size + 4);
      doc.text(line, marginX, y);
      y += size + 4;
    });
    y += 4;
  };

  const addBullet = (text, { size = 10 } = {}) => {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(size);
    doc.setTextColor(...INK_MUTED);
    const lines = doc.splitTextToSize(text, maxWidth - 14);
    lines.forEach((line, i) => {
      ensureSpace(size + 3);
      if (i === 0) {
        doc.setFillColor(...FOREST);
        doc.circle(marginX + 3, y - 3, 1.6, "F");
      }
      doc.text(line, marginX + 14, y);
      y += size + 3;
    });
  };

  // Header
  doc.setFillColor(...FOREST);
  doc.rect(0, 0, pageWidth, 6, "F");

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(...FOREST);
  doc.text(t("formationOnline.eyebrow").toUpperCase(), marginX, y);
  y += 20;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.setTextColor(...INK);
  const titleLines = doc.splitTextToSize(t("formationOnline.title"), maxWidth);
  titleLines.forEach((line) => {
    doc.text(line, marginX, y);
    y += 22;
  });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(...FOREST);
  doc.text(t("formationOnline.subtitle"), marginX, y);
  y += 24;

  addParagraph(t("formationOnline.intro"), { size: 10 });

  addHeading(t("formationOnline.for_you_title"), 12);
  ["for_you_1", "for_you_2", "for_you_3", "for_you_4"].forEach((k) =>
    addBullet(t(`formationOnline.${k}`))
  );
  y += 6;

  addHeading(t("formationOnline.modules_title"), 12);
  [
    ["module1_title", ["module1_1", "module1_2"]],
    ["module2_title", ["module2_1", "module2_2", "module2_3"]],
    ["module3_title", ["module3_1", "module3_2", "module3_3"]],
    ["module4_title", ["module4_1", "module4_2", "module4_3", "module4_4"]],
    ["module5_title", ["module5_1"]],
    ["module6_title", ["module6_1"]],
  ].forEach(([titleKey, itemKeys]) => {
    addParagraph(t(`formationOnline.${titleKey}`), { size: 10.5, bold: true, color: INK });
    itemKeys.forEach((k) => addBullet(t(`formationOnline.${k}`)));
  });
  y += 6;

  addHeading(t("formationOnline.dates_title"), 12);
  ["dates_1", "dates_2", "dates_3", "dates_4", "dates_5", "dates_6"].forEach((k) =>
    addBullet(t(`formationOnline.${k}`))
  );
  y += 6;

  addHeading(t("formationOnline.hours_title"), 12);
  addParagraph(t("formationOnline.hours_text"), { size: 10 });

  addHeading(t("formationOnline.formateurs_title"), 12);
  ["formateur_claire", "formateur_louise"].forEach((k) => addBullet(t(`formationOnline.${k}`)));

  addHeading(t("formationOnline.tarifs_title"), 12);
  ["tarifs_solidaire", "tarifs_personnel", "tarifs_commercial"].forEach((k) =>
    addBullet(t(`formationOnline.${k}`))
  );
  addParagraph(`${t("formationOnline.tarifs_signup")} ${t("formationOnline.tarifs_contact_email")}`, { size: 10 });
  addParagraph(t("formationOnline.tarifs_deposit"), { size: 10 });

  addHeading(t("formation.financing_title"), 12);
  addParagraph(t("formation.financing_intro"), { size: 10 });
  addParagraph("ecolepleinenature.org", { size: 9.5, bold: true, color: FOREST });

  const fileName = lang === "en" ? "EPN-online-training-brochure.pdf" : "EPN-brochure-formation-en-ligne.pdf";
  doc.save(fileName);
}
